/* Gravur-MAX Konfigurator v3: Aufbau und Bedienung. Eingabefelder, Namen und IDs bleiben die des Themes. */
(function(){
if(window.__gmCfgLoaded)return;
window.__gmCfgLoaded=true;
var GM=window.GM;
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
function fire(el,t){el.dispatchEvent(new Event(t,{bubbles:true}));}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function render(){GM.render();}
var CHECK='<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function init(root){
var rows=[],ok=true;
root.querySelectorAll('[input-main-wapper]').forEach(function(g){
var h=g.querySelector('.font-heading');
var input=g.querySelector('input[name^="properties[Dein Wunschtext"]');
var font=g.querySelector('input[name^="properties[Ausgew"]');
var ht=h?h.textContent:'';
var m=ht.match(/Glas\s*(\d+)/i);
/* 1-Glas-Variante: Ueberschrift ohne Glasnummer, aber mit (ueber/unter Motiv) */
if(!m&&/\((über|unter) Motiv\)/i.test(ht))m=[0,'1'];
if(!m||!input){ok=false;return;}
rows.push({g:g,h:h,input:input,font:font,glass:+m[1],kind:/Wunschname|unter Motiv/i.test(ht)?'name':'text',max:+input.getAttribute('maxlength')||25});
});
if(!ok||!rows.length)return;
var glasses={};
rows.forEach(function(r){(glasses[r.glass]=glasses[r.glass]||[]).push(r);});
var nums=Object.keys(glasses).map(Number).sort(function(a,b){return a-b;});
var multi=nums.length>1;
GM.fsz={};
rows[0].g.querySelectorAll('li[data-value]').forEach(function(li){GM.fsz[li.getAttribute('data-value')]=+li.getAttribute('data-font-size')||45;});
/* Theme-Fehler: alle Schriftfelder haben die ID selectedFont, die Auswahl landet im ersten Feld und die uebrigen stehen auf der letzten Schrift, angezeigt wird aber die erste.
   Wir merken uns die Wahl je Feld (r.chosen) und schreiben sie direkt und vor dem Absenden in das richtige versteckte Feld. */
rows.forEach(function(r){var li=r.g.querySelector('li[data-value]');r.chosen=li?li.getAttribute('data-value'):(r.font?r.font.value:'');});
function syncFonts(){rows.forEach(function(r){if(r.font&&r.chosen&&r.font.value!==r.chosen)r.font.value=r.chosen;});}
GM.syncFonts=syncFonts;
syncFonts();
rows.forEach(function(r){if(r.chosen)r.input.style.fontFamily=r.chosen+', sans-serif';});
document.addEventListener('submit',syncFonts,true);
document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.product-form__submit,.shopify-payment-button,form[action*="/cart/add"] [type=submit]'))syncFonts();},true);

var motif={name:'',img:''};
try{
var links=document.querySelectorAll('variant-selects-cust a.mo-item');
for(var i=0;i<links.length;i++){
if(links[i].getAttribute('href').split('?')[0]===location.pathname){
var t=links[i].querySelector('.item-title'),im=links[i].querySelector('img');
motif.name=t?t.textContent.trim():'';
if(im)motif.img=(im.getAttribute('src')||'').replace(/_\d+x(\.\w+)/,'_600x$1');
break;
}
}
}catch(e){}

var GP=window.GM_PREVIEW,cfg=null;
if(GP)cfg=multi?(GP.leer?{leer:GP.leer,wein:GP.wein}:null):(GP.leer1?{leer:GP.leer1,wein:GP.wein1}:null);
/* Foto-Vorschau nur fuer das vermessene Layout: Text oben, Motiv, Name unten */
if(cfg&&!(motif.img&&glasses[nums[0]].some(function(r){return r.kind==='text';})&&glasses[nums[0]].some(function(r){return r.kind==='name';})))cfg=null;
var wrap=document.createElement('section');
wrap.className='gm-cfg';
wrap.setAttribute('aria-labelledby','gm-cfg-title');
wrap.innerHTML='<div class="gm-step"><span class="gm-step__n" aria-hidden="true"></span><h2 class="gm-step__t" id="gm-cfg-title">Gravur gestalten</h2></div>'+
'<p class="gm-lead">Tippe deinen Text ein, die Vorschau zeigt ihn sofort'+(cfg?' auf dem Glas':'')+'.</p>'+
'<div class="gm-prev"></div>'+
'<div class="gm-tabs" role="tablist" aria-label="Gläser"></div>'+
'<div class="gm-panels"></div>'+
'<div class="gm-mini" aria-hidden="true"><span class="gm-mini__l"></span><span class="gm-mini__t"></span><span class="gm-mini__n"></span></div>';
var prev=wrap.querySelector('.gm-prev'),tabs=wrap.querySelector('.gm-tabs'),panels=wrap.querySelector('.gm-panels');
var cards={},state={active:nums[0]};
GM.rows=rows;GM.nums=nums;GM.cards=cards;GM.wrap=wrap;GM.state=state;

/* Vorschau */
if(cfg){
GM.photo=GM.buildPhoto(cfg,nums,motif.img);
GM.viewMap=GM.views(nums.length);
prev.appendChild(GM.photo);
var bar='<div class="gm-pbar"><div class="gm-seg" role="group" aria-label="Ansicht">';
bar+='<button type="button" data-v="all">'+(multi?'Beide Gläser':'Ganzes Glas')+'</button>';
nums.forEach(function(n,i){if(i<2)bar+='<button type="button" data-v="g'+(i+1)+'">'+(multi?'Glas '+n:'Nahansicht')+'</button>';});
bar+='</div>'+(cfg.wein?'<label class="gm-wine"><input type="checkbox"> Mit Weißwein</label>':'')+'</div>';
prev.insertAdjacentHTML('beforeend',bar);
prev.querySelector('.gm-seg').addEventListener('click',function(e){var b=e.target.closest('button');if(!b)return;var v=b.getAttribute('data-v');GM.setView(v);if(v!=='all'){var n=nums[+v.slice(1)-1];setActive(n,true);}});
var w=prev.querySelector('.gm-wine input');
if(w)w.addEventListener('change',function(){GM.photo.classList.toggle('is-wine',w.checked);});
GM.onView=function(k){prev.querySelectorAll('.gm-seg button').forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-v')===k?'true':'false');});};
GM.setView('all');
}else{
prev.appendChild(GM.buildText(nums,motif.name?'— '+esc(motif.name)+' —':''));
}
prev.insertAdjacentHTML('beforeend','<p class="gm-prev__note">Vorschau zur Orientierung. Größe und Position stimmen wir beim Gravieren auf das Glas ab.</p>');

function setSkip(r,on,quiet){
if(on){if(r.input.value!=='OHNE')r.saved=r.input.value;r.input.value='OHNE';r.input.readOnly=true;r.field.classList.add('is-skipped');}
else{r.input.value=r.saved||'';r.input.readOnly=false;r.field.classList.remove('is-skipped');}
r.cb.checked=on;
if(!quiet){fire(r.input,'input');fire(r.input,'change');GM.last='';render();}
}
function pickFont(rs,v){
rs.forEach(function(r){
r.chosen=v;
if(r.font&&r.font.value!==v){r.font.value=v;fire(r.font,'change');}
r.input.style.fontFamily=v+', sans-serif';
var st=r.g.querySelector('.selected-text');if(st)st.textContent=v;
});
GM.last='';render();
}
function fontList(host,from,targets){
var h='';
from.g.querySelectorAll('li[data-value]').forEach(function(li,i){
var v=li.getAttribute('data-value'),k=(GM.fsz[v]||45)/45;
h+='<button type="button" role="radio" class="gm-font" data-v="'+esc(v)+'" aria-checked="false"><span class="gm-font__s" style="font-family:\''+esc(v)+'\',cursive;font-size:calc(2.3rem * '+k.toFixed(3)+')">Anna &amp; Tom</span><span class="gm-font__l">Schrift '+(i+1)+'</span><span class="gm-font__c">'+CHECK+'</span></button>';
});
host.innerHTML=h;
host.__rows=targets;
host.addEventListener('click',function(e){var b=e.target.closest('.gm-font');if(b)pickFont(host.__rows,b.getAttribute('data-v'));});
}

nums.forEach(function(n,idx){
var list=glasses[n];
var tr=list.filter(function(r){return r.kind==='text';})[0];
var nr=list.filter(function(r){return r.kind==='name';})[0];
var ord=[tr,nr].filter(Boolean);
var pid='gm-panel-'+n,tid='gm-tab-'+n;
if(multi)tabs.insertAdjacentHTML('beforeend','<button type="button" role="tab" id="'+tid+'" aria-controls="'+pid+'" aria-selected="false" data-g="'+n+'"><span class="gm-tab__t">Glas '+n+'</span><span class="gm-tab__s"></span></button>');
var p=document.createElement('div');
p.className='gm-panel';
p.id=pid;
p.setAttribute('data-g',n);
if(multi){p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',tid);}
p.innerHTML=(idx>0?'<button type="button" class="gm-copy">Gravur von Glas '+nums[0]+' übernehmen</button>':'')+
'<div class="gm-fields"></div>'+
'<div class="gm-fontbox"><p class="gm-label" id="gm-fl-'+n+'">Schriftart</p><div class="gm-fonts" role="radiogroup" aria-labelledby="gm-fl-'+n+'"></div></div>'+
(nr&&tr?'<label class="gm-sep"><input type="checkbox"> Für den Namen eine andere Schrift wählen</label><div class="gm-fontbox gm-fontbox--name" hidden><p class="gm-label" id="gm-fln-'+n+'">Schriftart für den Namen</p><div class="gm-fonts gm-fonts--name" role="radiogroup" aria-labelledby="gm-fln-'+n+'"></div></div>':'');
var fe=p.querySelector('.gm-fields');
ord.forEach(function(r){
var lt=r.kind==='name'?'Name unter dem Motiv':'Text über dem Motiv';
var field=document.createElement('div');
field.className='gm-field';
r.input.id=r.input.id||('gm-in-'+n+r.kind);
field.innerHTML='<div class="gm-field__top"><label class="gm-label" for="'+r.input.id+'">'+lt+'</label><label class="gm-skip"><input type="checkbox"> Leer lassen</label></div><div class="gm-field__box"></div>';
var box=field.querySelector('.gm-field__box');
r.h.classList.add('gm-sr');
['.custom-dropdown','.namebox-heading'].forEach(function(s){var x=r.g.querySelector(s);if(x)x.classList.add('gm-sr');});
box.appendChild(r.g);
var count=document.createElement('span');
count.className='gm-count';
count.setAttribute('aria-hidden','true');
box.appendChild(count);
r.cb=field.querySelector('.gm-skip input');
r.cb.setAttribute('aria-label',lt+' leer lassen');
r.cb.addEventListener('change',function(){setSkip(r,r.cb.checked);});
fe.appendChild(field);
r.field=field;r.count=count;
r.input.setAttribute('autocomplete','off');
r.input.setAttribute('placeholder',r.kind==='name'?'z. B. Anna & Tom':'z. B. Für die beste Mama');
r.input.addEventListener('input',render);
r.input.addEventListener('focus',function(){setActive(n,true);});
r.input.addEventListener('invalid',function(){setActive(n,true);});
});
var main=p.querySelector('.gm-fonts:not(.gm-fonts--name)'),nc=p.querySelector('.gm-fonts--name');
var targets=ord.slice();
fontList(main,ord[0],targets);
if(nc){
fontList(nc,nr,[nr]);
p.querySelector('.gm-sep input').addEventListener('change',function(e){
var on=e.target.checked;
p.querySelector('.gm-fontbox--name').hidden=!on;
targets.length=0;
(on?[tr]:ord).forEach(function(r){targets.push(r);});
if(!on)pickFont(targets,tr.chosen);
GM.last='';render();
});
}
var cp=p.querySelector('.gm-copy');
if(cp)cp.addEventListener('click',function(){
glasses[nums[0]].forEach(function(s){
var d=list.filter(function(r){return r.kind===s.kind;})[0];
if(!d)return;
if(s.input.value==='OHNE')setSkip(d,true,true);
else{if(d.input.readOnly)setSkip(d,false,true);d.input.value=s.input.value;}
if(s.chosen)pickFont([d],s.chosen);
fire(d.input,'input');fire(d.input,'change');
});
GM.last='';render();
});
panels.appendChild(p);
cards[n]={panel:p,main:main,nameChips:nc,text:tr,name:nr};
});
if(!multi)tabs.remove();
else tabs.addEventListener('click',function(e){var b=e.target.closest('[role=tab]');if(b)setActive(+b.getAttribute('data-g'),true);});
if(multi)tabs.addEventListener('keydown',function(e){
if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;
var i=nums.indexOf(state.active)+(e.key==='ArrowRight'?1:-1);
i=(i+nums.length)%nums.length;
setActive(nums[i],true);
tabs.querySelector('[data-g="'+nums[i]+'"]').focus();
});
root.insertBefore(wrap,root.firstChild);

function setActive(n,zoom){
state.active=n;
if(multi){
tabs.querySelectorAll('[role=tab]').forEach(function(b){var on=+b.getAttribute('data-g')===n;b.setAttribute('aria-selected',on?'true':'false');b.tabIndex=on?0:-1;});
panels.querySelectorAll('.gm-panel').forEach(function(p){p.classList.toggle('is-off',+p.getAttribute('data-g')!==n);});
}
if(zoom&&GM.photo){var i=nums.indexOf(n);GM.setView(i<2?'g'+(i+1):'all');}
GM.last='';render();
}
GM.setActive=setActive;

GM.afterRender=function(){
nums.forEach(function(n){
var c=cards[n],total=0,done=0;
[c.text,c.name].forEach(function(r){
if(!r)return;
total++;if(GM.val(r))done++;
r.count.textContent=(r.input.value==='OHNE'?0:r.input.value.length)+'/'+r.max;
});
var okk=done===total;
var tb=tabs.querySelector('[data-g="'+n+'"] .gm-tab__s');
if(tb){tb.innerHTML=okk?CHECK:'';tb.parentNode.classList.toggle('is-done',okk);tb.parentNode.setAttribute('aria-label','Glas '+n+(okk?', fertig':', noch offen'));}
[c.main,c.nameChips].forEach(function(host){
if(!host||!host.__rows||!host.__rows[0])return;
var r0=host.__rows[0],cur=r0.chosen||'';
var s=GM.val(r0);
if(!s||s==='OHNE')s=GM.val(c.text)||GM.val(c.name);
if(!s||s==='OHNE')s='Anna & Tom';
host.querySelectorAll('.gm-font').forEach(function(b){
var on=b.getAttribute('data-v')===cur;
b.setAttribute('aria-checked',on?'true':'false');
var sp=b.firstChild;
if(sp.textContent!==s)sp.textContent=s;
});
});
});
var a=cards[state.active];
wrap.querySelector('.gm-mini__l').textContent=multi?'Glas '+state.active:'Deine Gravur';
[['.gm-mini__t',a.text],['.gm-mini__n',a.name]].forEach(function(q){
var el=wrap.querySelector(q[0]),v=GM.val(q[1]);
el.style.fontFamily='';
if(!q[1]||v==='OHNE'||!v){el.textContent='';return;}
el.textContent=v;
var f=q[1].chosen;
if(f)el.style.fontFamily='"'+f+'", cursive';
});
};

if(!multi)wrap.classList.add('gm-single');
setActive(nums[0],false);
setInterval(function(){syncFonts();render();},300);
if(window.ResizeObserver){try{new ResizeObserver(function(){GM.last='';render();}).observe(prev);}catch(e){}}
if(document.fonts&&document.fonts.addEventListener)document.fonts.addEventListener('loadingdone',function(){GM.last='';render();});
if(window.IntersectionObserver){
new IntersectionObserver(function(en){wrap.classList.toggle('gm-mini-on',!en[0].isIntersecting&&en[0].boundingClientRect.top<0);},{threshold:0}).observe(prev);
}
document.dispatchEvent(new CustomEvent('gm:cfg-ready'));
}

ready(function(){
var tries=0;
(function look(){
var root=document.querySelector('.main-wapper-input-customize');
if(root&&root.querySelector('[input-main-wapper]')){try{init(root);}catch(e){if(window.console)console.warn('gm-configurator',e);}return;}
if(++tries<20)setTimeout(look,250);
})();
});
})();